"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationFirstStep = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _GradientPanel = require("../../atoms/GradientPanel");

var _react = require("react");

var _LogoImage = require("../../atoms/LogoImage");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _TagAndInput = require("../../molecules/TagAndInput");

var _GeneralButton = require("../../atoms/GeneralButton");

var _GeneralInput = require("../../atoms/GeneralInput");

var _jsxRuntime = require("react/jsx-runtime");

var RegistrationFirstStep = function RegistrationFirstStep(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      emptyName = _useState2[0],
      setEmptyName = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      emptyLastName = _useState4[0],
      setEmptyLastName = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      emptyEmail = _useState6[0],
      setEmptyEmail = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      emptyJob = _useState8[0],
      setEmptyJob = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      emptyPhone = _useState10[0],
      setEmptyPhone = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      emptyCountry = _useState12[0],
      setEmptyCountry = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      invalidEmail = _useState14[0],
      setInvalidEmail = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      phoneFormatError = _useState16[0],
      setPhoneFormatError = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      regError = _useState18[0],
      setRegError = _useState18[1];

  (0, _react.useEffect)(function () {
    JSON.parse(sessionStorage.getItem("nuevoRegistro")).name === "" && sessionStorage.removeItem("registrationError");
    sessionStorage.getItem("registrationError") && setRegError(true);

    if (sessionStorage.getItem("registrationError")) {
      setEmptyName(false);
      setEmptyLastName(false);
      setEmptyEmail(false);
      setEmptyJob(false);
      setEmptyCountry(false);
      setEmptyPhone(false);
    }

    sessionStorage.getItem("resetPasswordProcess") && sessionStorage.getItem("resetPasswordProcess");
  }, []);

  var validate = function validate(evt) {
    var name = document.querySelector("#nameInput").value;
    var lastName = document.querySelector("#lastNameInput").value;
    var email = document.querySelector("#emailInput").value;
    var job = document.querySelector("#jobInput").value;
    var phone = document.querySelector("#phoneInput").value;
    var country = document.querySelector("#countrySelect").value;
    var countryCode = document.querySelector("#countryCodeSelect").value;
    var valid = true;
    evt.preventDefault();
    name === "" ? setEmptyName(true) : setEmptyName(false);
    lastName === "" ? setEmptyLastName(true) : setEmptyLastName(false);
    email === "" ? setEmptyEmail(true) : setEmptyEmail(false);
    job === "" ? setEmptyJob(true) : setEmptyJob(false);
    phone === "" ? setEmptyPhone(true) : setEmptyPhone(false);
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email) ? setInvalidEmail(true) : setInvalidEmail(false);
    var invalidPhone = true;
    country === "value" ? setEmptyCountry(true) : setEmptyCountry(false);
    Array.from(phone).forEach(function (digit, i) {
      phone.charCodeAt(i) < 48 ? setPhoneFormatError(true) : invalidPhone = false;
      phone.charCodeAt(i) > 57 ? setPhoneFormatError(true) : invalidPhone = false;
    });

    if (name === "" || lastName === "" || email === "" || job === "" || phone === "" || country === "value" || !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email) || invalidPhone) {
      valid = false;
    } else valid = true;

    var nuevoUsuario = JSON.parse(sessionStorage.getItem("nuevoRegistro"));

    if (valid) {
      sessionStorage.setItem("countryCode", JSON.stringify(countryCode));
      nuevoUsuario.name = name;
      nuevoUsuario.lastName = lastName;
      nuevoUsuario.email = email;
      nuevoUsuario.position = job;
      nuevoUsuario.phone = "".concat(JSON.parse(sessionStorage.getItem("countryCode"))).concat(phone);
      nuevoUsuario.country = country;
      sessionStorage.setItem("nuevoRegistro", JSON.stringify(nuevoUsuario));
      !regError && valid && props.setPaso(function (paso) {
        return props.paso + 1;
      });
      regError && valid && props.setPaso(4);
    }
  };

  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: "Ingresa tus credenciales"
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "user",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "name-registration-user",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
        inputType: "text",
        inputId: "nameInput",
        label: "Nombre",
        inputPlaceHolder: "Nombre",
        required: "required"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
        inputType: "text",
        inputId: "lastNameInput",
        label: "Apellido",
        inputPlaceHolder: "Apellido",
        required: "required"
      })]
    }), emptyName && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese su nombre"
    }), emptyLastName && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      className: "lastname",
      children: "Ingrese sus apellidos"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
      inputType: "text",
      inputId: "emailInput",
      label: "Correo electrónico",
      inputPlaceHolder: "username@contentoh.com",
      required: "required"
    }), regError && JSON.parse(sessionStorage.getItem("registrationError")) === "emailExists" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ya existe una cuenta asociada a este correo"
    }), emptyEmail && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese su email"
    }), invalidEmail && !emptyEmail && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese un correo v\xE1lido"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagAndInput.TagAndInput, {
      inputType: "text",
      inputId: "jobInput",
      label: "Puesto laboral",
      inputPlaceHolder: "Puesto dentro de la empresa",
      required: "required"
    }), emptyJob && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese su puesto"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: "Teléfono",
      headerType: "input-name-header"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "phone-registration-user",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
        name: "select",
        className: "phone-options",
        id: "countryCodeSelect",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+52"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+54"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+57"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+506"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+593"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+503"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+504"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+507"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          children: "+51"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralInput.GeneralInput, {
        inputId: "phoneInput",
        inputType: "text",
        inputPlaceholder: "Teléfono",
        required: "required"
      })]
    }), regError && JSON.parse(sessionStorage.getItem("registrationError")) === "phoneFormatError" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Introduzca un n\xFAmero v\xE1lido"
    }), emptyPhone && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese su n\xFAmero de tel\xE9fono"
    }), phoneFormatError && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Introduzca un n\xFAmero valido ( Solo numeros )"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: "País",
      headerType: "input-name-header"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
      name: "select",
      className: "country-options",
      id: "countrySelect",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "value",
        selected: true,
        children: "Selecciona tu pa\xEDs"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "Argentina",
        children: "Argentina"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "Colombia",
        children: "Colombia"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "Ecuador",
        children: "Ecuador"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "El Salvador",
        children: "El Salvador"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "Honduras",
        children: "Honduras"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "M\xE9xico",
        children: "M\xE9xico"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "Panam\xE1",
        children: "Panam\xE1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "Per\xFA",
        children: "Per\xFA"
      })]
    }), emptyCountry && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Seleccione su pa\xEDs"
    })]
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "button-end",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        validate(e);
      }
    })
  }, "4"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "progress-bar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "progress-bar-first-step"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "progress-bar-registration"
    })]
  }, "5"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
    text: "Paso 1",
    headerType: "date-header",
    color: _variables.GlobalColors.s4
  }, "6"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "new-login",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "pre-registro",
      onClick: function onClick() {
        return props.setPaso(7);
      },
      children: ["\xBFYa tienes una cuenta?", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: " Inicia Sesi\xF3n"
      })]
    })
  }, "7")];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
      componentsArray: loginRight,
      panelType: "home-login",
      panelColor: _variables.GlobalColors.white
    })
  });
};

exports.RegistrationFirstStep = RegistrationFirstStep;